import { PaginationState } from 'app/shared/pagination/pagination.model';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  fetchDeliveryOrderView,
  getDeliveryOrder,
  saveDeliveryOrder,
} from 'app/edozvola/cases/delivery-order/service/delivery-order.service';
import { showToast } from 'app/shared/util/toast.util';
import { DeliveryOrderModel } from 'app/edozvola/cases/delivery-order/model/delivery-order.model';
import { toast } from 'react-toastify';
import error = toast.error;
import success = toast.success;
import {messages} from "app/config/constants";

export const fetchDeliveryOrderViewQuery = (pagination: PaginationState, uuid: string) => {
  return useQuery({
    queryKey: ['delivery-order-table', { ...pagination }, uuid],
    queryFn: ({ signal }) => fetchDeliveryOrderView({ signal, pagination, uuid }),
  });
};

export const fetchDeliveryOrderQuery = (caseUuid: string) => {
  return useQuery({
    queryKey: ['delivery-order', caseUuid],
    queryFn: () => getDeliveryOrder(caseUuid),
    enabled: !!caseUuid,
  });
};

export const saveDeliveryOrderQuery = (caseUuid: string, resetFunction) => {
  return useMutation({
    mutationFn: (deliveryOrder: DeliveryOrderModel) => {
      return saveDeliveryOrder(caseUuid, deliveryOrder);
    },
    onSuccess: (data, variables) => {
      showToast(success, messages.DATA_SAVED);
      resetFunction({ values: variables });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
